module.exports = __webpack_public_path__ + "assets/img/icon.588e1d66.png";